import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, Input } from '@angular/core';
import * as moment from 'moment';
import { DeviceService } from '../../services/device.service';

@Component({
    selector: 'gaweb-datetime',
    templateUrl: `./datetime.component.html`
})
export class DatetimeComponent implements OnInit {
    @Input() datetime: Date;
    @Input() datestyle: string;
    constructor(private deviceService: DeviceService) {}
    ngOnInit(): void {
        this.datetime = moment(this.datetime, "DD/MM/YYYY hh:mm:ss A").toDate();
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/datetime/datetime.component.ts